// extracted by mini-css-extract-plugin
export default {"controlPanel":"ResultsView_controlPanel__dVPpl","dropdown":"ResultsView_dropdown__Zp1rn"};